import { render, staticRenderFns } from "./modifyRecordList.vue?vue&type=template&id=152306aa&scoped=true"
import script from "./modifyRecordList.vue?vue&type=script&lang=js"
export * from "./modifyRecordList.vue?vue&type=script&lang=js"
import style0 from "./modifyRecordList.vue?vue&type=style&index=0&id=152306aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152306aa",
  null
  
)

export default component.exports